import * as React from 'react';
import { connect } from 'react-redux';
import INotesAppState from './interfaces/notesAppState';
import IEditModal from './interfaces/editModal';
import { actionCreators } from './redux/actions';
import { NoteService } from '../../services/noteService';
import { createPortal } from 'react-dom';

type IEditModalLocalState = {
    nameValue: string;
    isVisible: boolean;
}
class EditModal extends React.Component<IEditModal, IEditModalLocalState> {
    constructor(props) {
        const { categories, display, selectedCategoryId } = props;
        const isVisible = categories && selectedCategoryId && display;
        super(props);
        this.state = {
            nameValue: props.editedCategoryName,
            isVisible: isVisible,
        }        
    }

    componentDidUpdate(prevProps: Readonly<IEditModal>, prevState: Readonly<IEditModalLocalState>) {
        if (prevProps.display !== this.props.display) {
            this.updateVisibility();
        }  
        if(prevProps.editedCategoryName !== this.props.editedCategoryName){
            this.setState({
                nameValue: this.props.editedCategoryName
            });
        }

        if(prevProps.selectedCategoryId !== this.props.selectedCategoryId){
            const category = this.props.categories.filter(c => c.categoryId === this.props.selectedCategoryId).pop();
            if (category) {
                this.setState({
                    nameValue: category.categoryName
                });
            }
        }
    }

    updateVisibility(){
        let isVisibleLocal = this.props.categories && this.props.selectedCategoryId && this.props.display;

        this.setState({
            isVisible: !!isVisibleLocal
        });
    }

    render() {
        return (
            createPortal(
                <React.Fragment>
                    {
                        this.state.isVisible
                            ? <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
                                <div className="bookmarks__modal-backdrop"></div>
                                <div className="bookmarks__modal-innercontainer">
                                    <button onClick={(event) => this.props.toggleEditModal && this.props.toggleEditModal(event)} className="modal__close">Stäng</button>
                                    <div className="modal__content">
                                        <h2 className="modal__title">Redigera kategori</h2>
                                        <div className="share-content">
                                            <div className="form-field  share-content__form-field">
                                                <input type="text" id="categoryName" className="share-content__email" defaultValue={this.state.nameValue} autoComplete="off" autoFocus onChange={(event) => { this.props.setEditedCategoryName && this.props.setEditedCategoryName(event, this.props.buttonIsDisabled) }} />
                                                <label className="share-content__label" htmlFor="categoryName">Namn på kategori</label>
                                            </div>
                                            <p className="bookmarks__paragraph">
                                                Om du väljer att ta bort denna kategori så kommer de favoriter som är kopplade flyttas till <strong>Okategoriserat</strong>. Inga favoriter kommer att tas bort.
                                            </p>
                                        </div>
                                        <div className="modalCTAs">
                                            <button className="genericBtn secondary" onClick={(event) => this.props.deleteEditedCategory && this.props.deleteEditedCategory(event, this.props.selectedCategoryId, this.props.categories)}>Ta bort kategori</button>
                                            <button className="genericBtn primary" disabled={this.props.buttonIsDisabled} onClick={(event) => { this.props.saveEditedCategoryName && this.props.saveEditedCategoryName(event, this.state.nameValue, this.props.selectedCategoryId, this.props.categories)}}>Spara ändring</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </React.Fragment>,
                document.body)
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): IEditModal => {
    const noteService = new NoteService();
    return {
        ...ownProps,
        toggleEditModal: (event) => {
            event.preventDefault();
            dispatch(actionCreators.toggleEditModal());
            dispatch(actionCreators.setEditedCategoryName(''));
        },
        saveEditedCategoryName: (event, editedCategoryName: string, categoryId: string, dataset: any[]) => {
            event.preventDefault();
    
            if (editedCategoryName) {
                const category = dataset.filter(c => c.categoryId === categoryId).pop();
                category.name = editedCategoryName;
                noteService.editCategory(category, (response) => {
                    if (!!response) {
                        dispatch(actionCreators.toggleEditModal());
                        const categories = dataset
                            .sort((a, b) => {
                                if (a.categoryName && b.categoryName) {
                                    if (a.categoryName > b.categoryName) {
                                        return 1;
                                    }
                                    return -1;
                                }
                            })
                            .map(x => {
                                if(x.categoryId === categoryId) {
                                    x.categoryName = response && response.id && response.name;
                                }
                                return x;
                            });
                        noteService.getNotes((success) => {
                            if (success) {
                                dispatch(actionCreators.setAllNotes(success));
                            }
                            dispatch(actionCreators.setAllCategories(categories));
                        }, (fail) => {
                            if (fail) {
                                console.error(fail)
                            }
                            dispatch(actionCreators.setAllCategories(categories));
                        });
                        dispatch(actionCreators.setAllCategories(categories));
                        dispatch(actionCreators.setToastBarType('success'));
                        dispatch(actionCreators.setToastBarMessage('Ändring sparades'));
                        dispatch(actionCreators.toggleToastBar());
                    }
                }, (error) => {
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte ändra kategori'));
                    dispatch(actionCreators.toggleToastBar());
                });
            }
        },
        deleteEditedCategory: (event, categoryId: string, dataset: any[]) => {
            event.preventDefault();
            const category = dataset.filter(c => c.categoryId === categoryId).pop();
            noteService.deleteCategory(category, (response) => {
                // the api service doesn't return the actual response object, success is an empty string for DELETE.
                dispatch(actionCreators.toggleEditModal())
                dispatch(actionCreators.setEditedCategoryName(''))
                noteService.getNoteCategories((data) => {
                    dispatch(actionCreators.setAllCategories(data));
                }, (err) => {
                    console.log('could not get categories', err)
                })
            }, (error) => {
                dispatch(actionCreators.setToastBarType('warn'));
                dispatch(actionCreators.setToastBarMessage('Något gick fel. Kunde inte ta bort kategori'));
                dispatch(actionCreators.toggleToastBar());
                console.error(error);
            });
        },
        setEditedCategoryName: (event, buttonIsDisabled) => {
            event.preventDefault();
            dispatch(actionCreators.setEditedCategoryName(event.target.value))
            if (buttonIsDisabled) {
                dispatch(actionCreators.toggleEditModalButton());
            }
            }
    };
}

const mapStateToProps = (state: INotesAppState): IEditModal => {
    return {
        display: state.displayEditModal,
        editedCategoryName: state.editedCategoryName,
        selectedCategoryId: state.selectedCategoryId,
        categories: state.categories,
        buttonIsDisabled: state.editModalButtonIsDisabled,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditModal);